import React from 'react';
import { styled } from 'styled-components';
import { Description as DescriptionTemplate, Title as TitleTemplate } from './MediaSectionWithShowDetailHeader';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionDetailHeader = ({
  sectionDetail
}) => {
  const {
    representation: {
      title,
      description
    }
  } = sectionDetail;
  return /*#__PURE__*/_jsxs(PlayContainer, {
    children: [/*#__PURE__*/_jsx(Title, {
      children: title
    }), description && /*#__PURE__*/_jsx(Description, {
      children: description
    })]
  });
};
const Title = styled(TitleTemplate).withConfig({
  displayName: "SectionDetailHeader__Title",
  componentId: "sc-1rcdr58-0"
})(["margin-top:36px;", "{margin-top:80px;}"], Viewports.for('mediumUp'));
const Description = styled(DescriptionTemplate).withConfig({
  displayName: "SectionDetailHeader__Description",
  componentId: "sc-1rcdr58-1"
})(["margin-bottom:6px;", "{margin-top:16px;margin-bottom:30px;}"], Viewports.for('mediumUp'));